<template>
  <a-modal
    v-model="dialogVisible"
    title="项目列表"
    :mask-closable="false"
    width="1200px"
    :footer="null"
  >
    <div class="body">
      <el-form :model="filterForm" label-width="100px" label-suffix="：" inline>
        <el-form-item label="招标名称">
          <el-input v-model="filterForm.orderName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select
            v-model="filterForm.biddingType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in projectTypeDict.array"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="招标方式">
          <el-select
            v-model="filterForm.bidMethod"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in bidInviteWayDict.array"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="operate">
          <div class="flex-align">
            <el-button type="primary" class="flex-center" @click="handleSearch">
              查询
            </el-button>
            <el-button class="flex-center" @click="handleReset">重置</el-button>
          </div>
        </el-form-item>
      </el-form>

      <jczh-table-content
        :data="list"
        :option="listOption"
        pagination
        :page.sync="page"
        :limit.sync="size"
        :total="total"
      >
        <template v-slot:last>
          <el-table-column
            label="操作"
            align="center"
            width="140"
            fixed="right"
          >
            <template v-slot:default="{ row }">
              <a-button type="link" @click="select(row)">选择此项目</a-button>
            </template>
          </el-table-column>
        </template>
      </jczh-table-content>
    </div>
  </a-modal>
</template>

<script>
// mixin
import listFilterMixin from '@/mixins/list-filter-mixin'
// 字典
import { bidInviteWayDict } from '@/dictionary/project/bid'
import { projectTypeDict } from '@/dictionary/project/common'
// 工具
import { strToThousands } from '@/utils/utils'
import { getAgencyServiceFeeProjectPageApi } from '@/api/agency/service-fee'

/**
 * @description 选择已完结招标项目给代理服务费收取
 */
export default {
  name: 'SelectBidForCharge',

  mixins: [listFilterMixin],

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      projectTypeDict,
      bidInviteWayDict,

      filterForm: {
        // 招标名称
        orderName: '',
        // 项目类型
        biddingType: '',
        // 招标方式
        bidMethod: ''
      },
      list: [],
      total: 0,
      listOption: [
        { label: '招标名称', prop: 'orderName' },
        { label: '项目名称', prop: 'projectName' },
        {
          label: '招标方式',
          prop: 'biddingMethod',
          filter: value => bidInviteWayDict.translate(value)?.label || '-'
        },
        {
          label: '项目类型',
          prop: 'biddingType',
          filter: value => projectTypeDict.translate(value)?.label || '-'
        },
        {
          label: '招标估算（万元）',
          prop: 'budget',
          filter: value => strToThousands(value || '-')
        }
      ]
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  watch: {
    visible(val) {
      if (val) this.getList()
    }
  },

  methods: {
    async getList() {
      this.epitaxy()

      try {
        const params = Object.assign({}, this.filterForm, {
          page: this.page,
          size: this.size
        })
        const _res = await getAgencyServiceFeeProjectPageApi(params)
        this.list = _res?.data?.records || []
        this.total = _res?.data?.total || 0
      } catch (err) {
        if (err?.message) this.$message.error(err.message)
      }
    },

    select(row) {
      this.$emit('select', row)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped></style>
